import { ClassNames } from '@emotion/react';
import { default as MuiTooltip, TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip/Tooltip';
import { FC } from 'react';

type Props = MuiTooltipProps & {
  width?: number;
};

export const Tooltip: FC<Props> = ({ children, width, ...rest }) => (
  <ClassNames>
    {({ css }) => (
      <MuiTooltip
        {...rest}
        classes={{
          tooltip: css`
            max-width: ${width ? `${width}px` : ''};
            padding: 16px;
            margin-right: 8px;
            margin-left: 8px;
          `,
        }}
      >
        {children}
      </MuiTooltip>
    )}
  </ClassNames>
);
